// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"d4951f64","631":"7d3edf77","774":"f5a9b149","787":"aaf0ea3f"}[chunkId] + ".chunk.js";
};